import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';

import {
  driveTrainCountState,
  drivetrainTypeSearchOptionsSelector,
  drivetrainTypesState,
  hasSelectedDrivetrainFilterSelector,
  resetSelectedDrivetrainTypesSelector,
  selectDrivetrainTypeSelector,
  selectedDrivetrainTypesSelector,
  toggleDrivetrainTypeSelector,
  visibleDrivetrainTypeSelector,
} from '@/states/filters/drivetrain.state';

export function useDrivetrainFilter() {
  const [drivetrainTypesFilter, setDrivetrainTypesFilter] =
    useRecoilState(drivetrainTypesState);
  const [driveTrainCount, setDriveTrainCount] =
    useRecoilState(driveTrainCountState);
  const drivetrainTypeSearchOptions = useRecoilValue(
    drivetrainTypeSearchOptionsSelector
  );
  const toggleDrivetrainType = useSetRecoilState(toggleDrivetrainTypeSelector);
  const selectDrivetrainType = useSetRecoilState(selectDrivetrainTypeSelector);
  const selectedDrivetrainTypes = useRecoilValue(
    selectedDrivetrainTypesSelector
  );
  const resetSelectedDrivetrainTypes = useSetRecoilState(
    resetSelectedDrivetrainTypesSelector
  );
  const hasSelectedDrivetrainFilter = useRecoilValue(
    hasSelectedDrivetrainFilterSelector
  );

  const visibleDrivetrainTypeFilter = useRecoilValue(
    visibleDrivetrainTypeSelector
  );

  return {
    drivetrainTypesFilter,
    setDrivetrainTypesFilter,
    driveTrainCount,
    setDriveTrainCount,
    drivetrainTypeSearchOptions,
    toggleDrivetrainType,
    selectedDrivetrainTypes,
    resetSelectedDrivetrainTypes,
    hasSelectedDrivetrainFilter,
    selectDrivetrainType,
    visibleDrivetrainTypeFilter,
  };
}
